import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import ArrayList from './ArrayList';
import MapInterface from './Map';
import HashSet from './HashSet';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/HashMap.html
 */
var HashMap = /*#__PURE__*/function (_MapInterface) {
  _inherits(HashMap, _MapInterface);
  function HashMap() {
    var _this;
    _classCallCheck(this, HashMap);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HashMap).call(this));
    _this.map = new Map();
    return _this;
  }
  _createClass(HashMap, [{
    key: "get",
    value: function get(key) {
      return this.map.get(key) || null;
    }
  }, {
    key: "put",
    value: function put(key, value) {
      this.map.set(key, value);
      return value;
    }
  }, {
    key: "values",
    value: function values() {
      var arrayList = new ArrayList();
      var it = this.map.values();
      var o = it.next();
      while (!o.done) {
        arrayList.add(o.value);
        o = it.next();
      }
      return arrayList;
    }
  }, {
    key: "entrySet",
    value: function entrySet() {
      var hashSet = new HashSet();
      this.map.entries().forEach(function (entry) {
        return hashSet.add(entry);
      });
      return hashSet;
    }
  }, {
    key: "size",
    value: function size() {
      return this.map.size();
    }
  }]);
  return HashMap;
}(MapInterface);
export { HashMap as default };